import { all, takeEvery, put, call } from 'redux-saga/effects';
import actions from "./actions";
import { CountryType } from "./country.type";
import { getCountriesApi } from "../../services/countries.service";
import { AxiosResponse } from 'axios';
import logError from "../../utils/logError";

export function* GET_ALL_COUNTRIES() {
    try {
        const response: AxiosResponse<any> = yield call(getCountriesApi);
        if (response.data) {
            const data = response.data.map((el: CountryType, key: Number) => ({...el, key: (Number(key) + 1)}));
            yield put({
                type: actions.SET_DATA,
                payload: data
            })
        }
    } catch (e) { logError("redux/countries/sagas/GET_ALL_COUNTRIES", e); }
}

export default function* rootSaga() {
    yield all([
        takeEvery(actions.GET_DATA, GET_ALL_COUNTRIES),
    ])
}
